import React, { useState, useEffect } from 'react';

const ImageGallery = ({ washroomId }) => {
  const [images, setImages] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  useEffect(() => {
    if (!washroomId) return;

    const checkImage = (url) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
      });
    };

    const loadImages = async () => {
      const validImages = [];
      
      // Check first 10 images
      for (let i = 1; i <= 10; i++) {
        const imageUrl = `/images/washrooms/${washroomId}/${i}.jpg`;
        const exists = await checkImage(imageUrl);
        
        if (exists) {
          validImages.push(imageUrl);
        } else {
          // Stop checking once we find a missing image
          break;
        }
      }
      
      setImages(validImages);
    };

    loadImages();
  }, [washroomId]);

  const handleImageError = (failedUrl) => {
    // Remove failed image URL from the array
    console.log("error");
    setImages(currentImages => 
      currentImages.filter(url => url !== failedUrl)
      
    );
  };

  const ImageModal = ({ isOpen, onClose, currentIndex }) => {
    if (!isOpen) return null;

    const handleNext = (e) => {
      e.stopPropagation();
      setSelectedImageIndex((currentIndex + 1) % images.length);
    };

    const handlePrevious = (e) => {
      e.stopPropagation();
      setSelectedImageIndex((currentIndex - 1 + images.length) % images.length);
    };

    return (
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            background: 'transparent',
            border: 'none',
            color: 'white',
            fontSize: '24px',
            cursor: 'pointer',
            zIndex: 1001
          }}
        >
          ×
        </button>
        <button
          onClick={handlePrevious}
          style={{
            position: 'absolute',
            left: '20px',
            background: 'rgba(255, 255, 255, 0.3)',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            cursor: 'pointer'
          }}
        >
          ‹
        </button>
        <img
          src={images[currentIndex]}
          alt={`Gallery image ${currentIndex + 1}`}
          style={{
            maxHeight: '90vh',
            maxWidth: '90vw',
            objectFit: 'contain'
          }}
        />
        <button
          onClick={handleNext}
          style={{
            position: 'absolute',
            right: '20px',
            background: 'rgba(255, 255, 255, 0.3)',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            cursor: 'pointer'
          }}
        >
          ›
        </button>
        <div
          style={{
            position: 'absolute',
            bottom: '20px',
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            padding: '8px 16px',
            borderRadius: '20px'
          }}
        >
          {currentIndex + 1} / {images.length}
        </div>
      </div>
    );
  };

  return (
    <div style={{ marginBottom: '24px' }}>
      {images.length > 0 ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px'
        }}>
          <div style={{
            display: 'flex',
            gap: '4px',
            aspectRatio: '16/9',
            width: '100%'
          }}>
            <div
              onClick={() => setSelectedImageIndex(0)}
              style={{
                flex: '2',
                position: 'relative',
                cursor: 'pointer',
                borderRadius: '8px',
                overflow: 'hidden'
              }}
            >
              <img
                src={images[0]}
                alt="Main"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>

            <div style={{
              flex: '1',
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}>
              {images.slice(1, 3).map((image, index) => (
                <div
                  key={index}
                  onClick={() => setSelectedImageIndex(index + 1)}
                  style={{
                    flex: '1',
                    position: 'relative',
                    cursor: 'pointer',
                    borderRadius: '8px',
                    overflow: 'hidden'
                  }}
                >
                  <img
                    src={image}
                    alt={`Thumbnail ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                  {index === 1 && images.length > 3 && (
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '16px'
                    }}>
                      +{images.length - 3} more
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div style={{
          aspectRatio: '16/9',
          width: '100%',
          backgroundColor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#666',
          borderRadius: '8px'
        }}>
          No images available
        </div>
      )}

      <ImageModal
        isOpen={selectedImageIndex !== null}
        onClose={() => setSelectedImageIndex(null)}
        currentIndex={selectedImageIndex || 0}
      />
    </div>
  );
};

export default ImageGallery; 